import React from 'react';
import { st, classes } from './role-badge.st.css';
export const RoleBadge = ({ className, label, }) => {
    return (React.createElement("div", { className: st(classes.root, className) },
        React.createElement("div", { className: classes.label }, label)));
};
//# sourceMappingURL=role-badge.js.map